import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Label,
  Input,
  Form,
  FormGroup,
  Progress,
  Container,
} from "reactstrap";
import { api_route } from "../../Api-config/config";
import classnames from "classnames";
import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

class DealerProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Delisted Stocks", link: "#" },
        { title: "Profile", link: "#" },
      ],
      activeTab: 1,
      activeTabProgress: 1,
      progressValue: 25,
      tableData: [],
    };
    this.toggleTab.bind(this);
    this.toggleTabProgress.bind(this);
  }

  componentDidMount() {
    this.fetchProfile();
  }

  fetchProfile = () => {
    fetch(api_route + "/dealer/profile", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + sessionStorage.getItem("token"),
      },
      body: JSON.stringify({
        id: sessionStorage.getItem("dealerId"),
      }),
    })
      .then((response) => response.json())
      .then((json) => {
        this.setState({ tableData: json, isLoading: false });
        console.log(json);
      });
  };

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({
          activeTab: tab,
        });
      }
    }
  }

  toggleTabProgress(tab) {
    if (this.state.activeTabProgress !== tab) {
      if (tab >= 1 && tab <= 4) {
        this.setState({
          activeTabProgress: tab,
        });

        if (tab === 1) {
          this.setState({ progressValue: 25 });
        }
        if (tab === 2) {
          this.setState({ progressValue: 50 });
        }
        if (tab === 3) {
          this.setState({ progressValue: 75 });
        }
        if (tab === 4) {
          this.setState({ progressValue: 100 });
        }
      }
    }
  }

  render() {
    if (this.state.tableData.length === 0) {
      return (
        <React.Fragment>
          <div className="page-content">
            <Container fluid={true}>
              <Breadcrumbs
                title="Profile"
                breadcrumbItems={this.state.breadcrumbItems}
              />

              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <div
                        id="basic-pills-wizard"
                        className="twitter-bs-wizard"
                      >
                        <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: this.state.activeTab === 1,
                              })}
                              onClick={() => {
                                this.toggleTab(1);
                              }}
                            >
                              <span className="step-number">01</span>
                              <span className="step-title">Dealer Details</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: this.state.activeTab === 2,
                              })}
                              onClick={() => {
                                this.toggleTab(2);
                              }}
                            >
                              <span className="step-number">02</span>
                              <span className="step-title">Bank Details</span>
                            </NavLink>
                          </NavItem>
                        </ul>
                        <TabContent
                          activeTab={this.state.activeTab}
                          className="twitter-bs-wizard-tab-content"
                        >
                          <TabPane tabId={1}>
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="fullName">Full name</Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-firstname-input1"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].full_name
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-phoneno-input3">
                                      Phone
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-phoneno-input3"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].phone
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-email-input4">
                                      Email
                                    </Label>
                                    <Input
                                      type="email"
                                      className="form-control"
                                      id="basicpill-email-input4"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].email
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-address-input1">
                                      PAN Number
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-email-input4"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].panNo
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <Label for="basicpill-address-input1">
                                      Address
                                    </Label>
                                    <textarea
                                      id="basicpill-address-input1"
                                      className="form-control"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].address
                                          : ""
                                      }
                                      rows="2"
                                      readonly
                                      disabled
                                    ></textarea>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-pancard-input5">
                                        Bank Name
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-pancard-input5"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].bankName
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-vatno-input6">
                                        Bank Account No.
                                      </Label>
                                      <Input
                                        type="number"
                                        className="form-control"
                                        id="basicpill-vatno-input6"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].bankAccNo
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-cstno-input7">
                                        Account Type
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-servicetax-input8"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].accType
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-servicetax-input8">
                                        IFSC Code
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-servicetax-input8"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].ifscCode
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-companyuin-input9">
                                        Branch
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-companyuin-input9"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].branch
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </TabPane>
                        </TabContent>
                        <ul className="pager wizard twitter-bs-wizard-pager-link">
                          <li
                            className={
                              this.state.activeTab === 1
                                ? "previous disabled"
                                : "previous"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                this.toggleTab(this.state.activeTab - 1);
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.activeTab === 2
                                ? "next disabled"
                                : "next"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                this.toggleTab(this.state.activeTab + 1);
                              }}
                            >
                              Next
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="page-content">
            <Container fluid={true}>
              <Breadcrumbs
                title="Profile"
                breadcrumbItems={this.state.breadcrumbItems}
              />

              <Row>
                <Col lg="12">
                  <Card>
                    <CardBody>
                      <div
                        id="basic-pills-wizard"
                        className="twitter-bs-wizard"
                      >
                        <ul className="twitter-bs-wizard-nav nav nav-pills nav-justified">
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: this.state.activeTab === 1,
                              })}
                              onClick={() => {
                                this.toggleTab(1);
                              }}
                            >
                              <span className="step-number">01</span>
                              <span className="step-title">Dealer Details</span>
                            </NavLink>
                          </NavItem>
                          <NavItem>
                            <NavLink
                              className={classnames({
                                active: this.state.activeTab === 2,
                              })}
                              onClick={() => {
                                this.toggleTab(2);
                              }}
                            >
                              <span className="step-number">02</span>
                              <span className="step-title">Bank Details</span>
                            </NavLink>
                          </NavItem>
                        </ul>
                        <TabContent
                          activeTab={this.state.activeTab}
                          className="twitter-bs-wizard-tab-content"
                        >
                          <TabPane tabId={1}>
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="fullName">Full name</Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-firstname-input1"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].full_name
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-phoneno-input3">
                                      Phone
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-phoneno-input3"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].phone
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-email-input4">
                                      Email
                                    </Label>
                                    <Input
                                      type="email"
                                      className="form-control"
                                      id="basicpill-email-input4"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].email
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label for="basicpill-address-input1">
                                      PAN Number
                                    </Label>
                                    <Input
                                      type="text"
                                      className="form-control"
                                      id="basicpill-email-input4"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].panNo
                                          : ""
                                      }
                                      readonly
                                      disabled
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>
                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <Label for="basicpill-address-input1">
                                      Address
                                    </Label>
                                    <textarea
                                      id="basicpill-address-input1"
                                      className="form-control"
                                      defaultValue={
                                        this.state.tableData.length > 0
                                          ? this.state.tableData[0].address
                                          : ""
                                      }
                                      rows="2"
                                      readonly
                                      disabled
                                    ></textarea>
                                  </FormGroup>
                                </Col>
                              </Row>
                            </Form>
                          </TabPane>
                          <TabPane tabId={2}>
                            <div>
                              <Form>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-pancard-input5">
                                        Bank Name
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-pancard-input5"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].bankName
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-vatno-input6">
                                        Bank Account No.
                                      </Label>
                                      <Input
                                        type="number"
                                        className="form-control"
                                        id="basicpill-vatno-input6"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].bankAccNo
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-cstno-input7">
                                        Account Type
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-servicetax-input8"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].accType
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>

                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-servicetax-input8">
                                        IFSC Code
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-servicetax-input8"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].ifscCode
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg="6">
                                    <FormGroup>
                                      <Label for="basicpill-companyuin-input9">
                                        Branch
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        id="basicpill-companyuin-input9"
                                        defaultValue={
                                          this.state.tableData.length > 0
                                            ? this.state.tableData[0].branch
                                            : ""
                                        }
                                        readonly
                                        disabled
                                      />
                                    </FormGroup>
                                  </Col>
                                </Row>
                              </Form>
                            </div>
                          </TabPane>
                        </TabContent>
                        <ul className="pager wizard twitter-bs-wizard-pager-link">
                          <li
                            className={
                              this.state.activeTab === 1
                                ? "previous disabled"
                                : "previous"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                this.toggleTab(this.state.activeTab - 1);
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              this.state.activeTab === 2
                                ? "next disabled"
                                : "next"
                            }
                          >
                            <Link
                              to="#"
                              onClick={() => {
                                this.toggleTab(this.state.activeTab + 1);
                              }}
                            >
                              Next
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </React.Fragment>
      );
    }
  }
}

export default DealerProfile;
